export enum MomentLocale {
  Croatian = "hr",
}
